import React from 'react';
import styled, { keyframes } from 'styled-components';

const Loading = ({ text, height }) => (
    <LoadingWrapper  height={height}>
        <LoadingStyle />
        {text && <LoadingText>{text}</LoadingText>}
    </LoadingWrapper>
);

export default Loading;

const LoadingWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: ${({ height }) => height || '100px'};
    justify-content: center;
    padding: 1.5rem;
`;

const LoadingText = styled.div`
    font-size: 0.875rem;
    margin-top: 1rem;
`;

const LoadingStyle = styled.div`
    animation: ${dotFallingBuilder()} 1s infinite linear;
    animation-delay: .1s;
    background-color: var(--main-color);
    border-radius: 0.5rem;
    box-shadow: 9999px 0 0 0 var(--main-color);
    color: var(--main-color);
    height: 1rem;
    left: -9999px;
    position: relative;
    width: 1rem;

    &:before, &:after {
        background-color: var(--main-color);
        border-radius: 0.5rem;
        color: var(--main-color);
        content: '';
        display: inline-block;
        height: 1rem;
        position: absolute;
        top: 0;
        width: 1rem;
    }

    &:before {
        animation: ${dotFallingBeforeBuilder()} 1s infinite linear;
        animation-delay: 0s;
        left: -0.5rem;
    }

    &:after {
        animation: ${dotFallingAfterBuilder()} 1s infinite linear;
        animation-delay: .2s;
        left: 0.5rem;
    }
`;

function dotFallingBuilder() {
	const dotFalling = keyframes`
		0% { box-shadow: 9999px -15px 0 0 rgba(152, 128, 255, 0); }
        25%,
        50%,
        75% { box-shadow: 9999px 0 0 0 var(--main-color); }
        100% { box-shadow: 9999px 15px 0 0 rgba(152, 128, 255, 0); }
	`;
	return dotFalling;
}

function dotFallingBeforeBuilder() {
	const dotFallingBefore = keyframes`
		0% { box-shadow: 9984px -15px 0 0 rgba(152, 128, 255, 0); }
        25%,
        50%,
        75% { box-shadow: 9984px 0 0 0 var(--main-color); }
        100% { box-shadow: 9984px 15px 0 0 rgba(152, 128, 255, 0); }
	`;
	return dotFallingBefore;
}

function dotFallingAfterBuilder() {
	const dotFallingAfter = keyframes`
		0% { box-shadow: 10014px -15px 0 0 rgba(152, 128, 255, 0); }
        25%,
        50%,
        75% { box-shadow: 10014px 0 0 0 var(--main-color); }
        100% { box-shadow: 10014px 15px 0 0 rgba(152, 128, 255, 0); }
	`;
	return dotFallingAfter;
}
